import type { SVGProps } from "react";
const SvgNumber11 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="53.434pt"
    height="75.803pt"
    viewBox="132.072 -313.712 53.434 75.803"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 139.944,305.097 C 140.363,305.346 140.826,305.504 141.334,305.571 L 154.848,307.359 C 155.165,307.401 155.433,307.324 155.653,307.127 C 155.873,306.93 155.972,306.669 155.951,306.343 L 156.57,240.964 C 156.549,240.638 156.442,240.349 156.249,240.098 C 156.057,239.847 155.802,239.7 155.484,239.658 L 142.351,237.92 C 142.034,237.878 141.765,237.956 141.546,238.153 C 141.326,238.349 141.227,238.611 141.248,238.936 L 140.793,289.909 C 140.751,290.226 140.603,290.368 140.349,290.334 L 133.452,289.034 C 132.754,288.942 132.391,289.249 132.362,289.955 L 132.073,300.182 C 132.052,300.825 132.347,301.283 132.956,301.557 L 139.944,305.097 Z"
                  markerStart="none"
                  markerEnd="none"
                />
                <path
                  d="M 166.702,308.637 C 167.121,308.886 167.584,309.044 168.091,309.111 L 181.606,310.899 C 181.923,310.941 182.191,310.864 182.411,310.667 C 182.631,310.47 182.73,310.209 182.708,309.883 L 183.328,244.504 C 183.307,244.178 183.2,243.89 183.007,243.638 C 182.814,243.387 182.56,243.24 182.242,243.198 L 169.109,241.46 C 168.792,241.419 168.523,241.496 168.303,241.693 C 168.084,241.89 167.984,242.151 168.006,242.477 L 167.551,293.449 C 167.509,293.766 167.361,293.908 167.107,293.875 L 160.21,292.575 C 159.512,292.482 159.149,292.789 159.12,293.496 L 158.831,303.722 C 158.81,304.365 159.105,304.823 159.714,305.098 L 166.702,308.637 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 142.122,307.899 C 142.541,308.148 143.004,308.306 143.512,308.373 L 157.026,310.161 C 157.343,310.203 157.611,310.126 157.831,309.929 C 158.051,309.732 158.15,309.471 158.129,309.145 L 158.748,243.766 C 158.727,243.44 158.62,243.151 158.427,242.9 C 158.235,242.649 157.98,242.502 157.662,242.46 L 144.529,240.722 C 144.212,240.68 143.943,240.758 143.724,240.955 C 143.504,241.151 143.405,241.413 143.426,241.738 L 142.971,292.711 C 142.929,293.028 142.781,293.17 142.527,293.136 L 135.63,291.836 C 134.932,291.744 134.569,292.051 134.54,292.757 L 134.251,302.984 C 134.23,303.627 134.525,304.085 135.134,304.359 L 142.122,307.899 Z"
                  markerStart="none"
                  markerEnd="none"
                />
                <path
                  d="M 168.88,311.439 C 169.299,311.688 169.762,311.846 170.269,311.913 L 183.784,313.701 C 184.101,313.743 184.369,313.666 184.589,313.469 C 184.809,313.272 184.908,313.011 184.886,312.685 L 185.506,247.306 C 185.485,246.98 185.378,246.692 185.185,246.44 C 184.992,246.189 184.738,246.042 184.42,246 L 171.287,244.262 C 170.97,244.22 170.701,244.298 170.481,244.495 C 170.262,244.692 170.162,244.953 170.184,245.279 L 169.729,296.251 C 169.687,296.568 169.539,296.71 169.285,296.677 L 162.388,295.377 C 161.69,295.284 161.327,295.591 161.298,296.298 L 161.009,306.524 C 160.988,307.167 161.283,307.625 161.892,307.9 L 168.88,311.439 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber11;
